// extracted by mini-css-extract-plugin
export default {"Carousel":"Carousel_Carousel__euRix","carousel_slide":"Carousel_carousel_slide__Z2iYO","carousel_img":"Carousel_carousel_img__+K2vh","carousel_text":"Carousel_carousel_text__S2H-D"};